import React from "react";
import {
  FormControl,
  Input,
  Paper,
  Tooltip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Draggable } from "react-beautiful-dnd";
import moment from "moment";
// import DatePicker from "react-datepicker";
import { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Person from "@material-ui/icons/Person";
import Event from "@material-ui/icons/Event";

const useStyle = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(1, 1, 1, 2),
    margin: theme.spacing(1),
  },
}));

export default function Card({
  card,
  index,
  handleClickExibirDescricao,
  alterarDataTicket,
  urlSacOnline,
}) {
  const classes = useStyle();

  const [modal, setModal] = useState(false);
  const [data, setData] = useState(moment().startOf("day").toDate());

  const [type, setType] = useState("");

  return (
    <React.Fragment>
      <Draggable draggableId={card.id} index={index}>
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.dragHandleProps}
            {...provided.draggableProps}
          >
            <Paper className={classes.card}>
              {/* <Tooltip
                                title={card.title}
                                arrow
                                placement="right"
                              > */}
              <div
                style={{
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                  justifyContent: "center",
                }}
              >
                <Tooltip title={card.situacaoDesc} arrow placement="top">
                  <div
                    style={{
                      width: "15px",
                      height: "15px",
                      backgroundColor: card.situacaoCor,
                      minWidth: "15px",
                      minHeight: "15px",
                      borderRadius: "4px",
                      border: "1px solid #ffffff88",
                    }}
                  ></div>
                </Tooltip>
                &nbsp;&nbsp;
                <Tooltip title={card.title} arrow placement="right">
                  <span
                    onClick={() => {
                      let typeUrl = "tickets";

                      if (card.type === "pre-ticket") {
                        typeUrl = "pre-tickets";
                      }

                      window.open(
                        `${urlSacOnline}/${typeUrl}/detail/${card.id}`,
                        "_blank"
                      );
                    }}
                    style={{marginTop:"2px"}}
                  >
                    {" "}
                    {card.title}
                  </span>
                </Tooltip>
              </div>
              {/* </Tooltip> */}

              <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
                <div style={{ width: "30%" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Person />
                    {card.fantasia.split(" ")[0]}
                  </div>
                </div>
                <div
                  style={{
                    width: "70%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Event />
                    Emissao: {card.dataEmissao}
                  </div>
                </div>
              </div>

              {/* <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
              <div style={{ width: "30%" }}>
              <div onClick={() => handleClickExibirDescricao(card.descricao)}>
              +
            </div>
              </div>
            
            </div> */}

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  width: "100%",
                  justifyContent: "center",
                  borderTop: "1px solid #5a605a",
                  marginTop: "5px",
                  paddingTop: "10px",
                }}
              >
                <div
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={() => {
                    if (card.dtEntrega !== null) {
                      setData(moment(card.dtEntrega).toDate());
                    } else {
                      setData(null);
                    }
                    setModal(true);
                    setType(card.type);
                  }}
                >
                  <Event style={{ color: "#08836a" }} />
                  &nbsp;Entrega:{" "}
                  {card.dtEntrega === null ? (
                    <span style={{ textDecoration: "underline" }}>
                      &nbsp;SEM DATA
                    </span>
                  ) : (
                    moment(card.dtEntrega).format("DD/MM")
                  )}
                </div>
              </div>
            </Paper>
          </div>
        )}
      </Draggable>

      <Dialog
        onClose={() => setModal(false)}
        aria-labelledby="customized-dialog-title"
        open={modal}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => setModal(false)}
        >
          Data Entrega
        </DialogTitle>
        <DialogContent dividers>
          <FormControl variant="standard" fullWidth>
            {/* <InputLabel htmlFor="meu-input">Data</InputLabel> */}
            <Input
              id="meu-input"
              type="date"
              value={moment(data).format("YYYY-MM-DD")}
              onChange={(e) => setData(e.target.value)}
              required
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              alterarDataTicket(
                card.id,
                moment(data).startOf("day").toDate(),
                type
              );
              setModal(false);
            }}
            color="primary"
          >
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
